import React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  newCompany?: boolean;
}

const LoginHeader: React.FC<Props> = (props) => {
  const { newCompany } = props;

  return (
    <Box textAlign="center" marginBottom={4}>
      <img
        height={"100%"}
        width={450}
        src={"/static/images/SVPro.png"}
        alt="logo"
        style={{
          marginTop: "-70px",
          marginBottom: "-120px",
          objectFit: "cover",
          maxWidth: "100%",
        }}
      />
      {!!newCompany && (
        <Typography variant="h5" color="primary" fontWeight="bold">
          Welcome to SVPRO! Enter details to create a new account below. Company
          information will be collected on the next screen.
        </Typography>
      )}
    </Box>
  );
};

export default LoginHeader;
